import { InjectionToken } from '@angular/core';

export const FLOORI_STORAGE_PROVIDER = new InjectionToken('FLOORI_STORAGE_PROVIDER');
